<template>
  <main class="content pb-50 pt-30" style="min-height: 800px;">
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <Sidenav />
        </div>
        <div class="col-md-9">
          <h2 class="header-title">My Profile</h2>
          <div v-if="user && Object.keys(user).length" class="profile-details mt-20">
            <transition name="component-fade" mode="out-in">
              <component v-bind:is="currentComponent" @change-component="changeComponent" @change-title="changeTitle"
                @get-customer-profile="getCustomerProfile" :title="title"></component>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
import $ from "jquery";
import Details from "@/components/profile/Details.vue";
import EditName from "@/components/profile/EditName.vue";
import EditPIN from "@/components/profile/EditPIN.vue";
import EditKeyAccount from "@/components/profile/EditKeyAccount.vue";
import Success from "@/components/profile/Success.vue";
import Verify from "@/components/profile/Verify.vue";
import Sidenav from "@/components/layout/Sidenav.vue";
import EditMobileNumber from "@/components/profile/EditMobileNumber/EditMobileNumber";

export default {
  data() {
    return {
      currentComponent: "Details",
      title: ""
    };
  },
  computed: {
    ...mapState("auth", {
      token: state => state.token,
      authErrors: state => state.errors,
      authIsLoading: state => state.loading
    }),
    ...mapState("customer", {
      user: state => state.user,
      customerErrors: state => state.errors,
      customerIsLoading: state => state.loading
    }),
    ...mapState("merchant", {
      subdomain: state => state.subdomain,
      customerPortalToken: state => state.customerPortalToken,
      merchantIsLoading: state => state.loading,
      merchantErrors: state => state.errors
    })
  },
  components: {
    Details,
    EditName,
    EditPIN,
    EditKeyAccount,
    Success,
    Verify,
    Sidenav,
    EditMobileNumber
  },
  created: function () {
    this.getCustomerProfile();
  },
  methods: {
    changeComponent(component) {
      this.currentComponent = component;
      if (component === 'Details') this.getCustomerProfile();
    },
    changeTitle(title) {
      this.title = title;
    },
    async getCustomerProfile() {
      let request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken
        }
      };
      await this.$store.dispatch("customer/getCustomerProfile", request);
    }
  },
  mounted: () => {
    $("body").css({ backgroundColor: "#f4f5f8" });
  },
};
</script>

<style scoped lang="scss">
@import "./../../assets/styles/views/profile/_base.scss";
</style>
